module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Copyright © 1999 by Lily King")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in"), _c('br'), _vm._v("any form or by any electronic or mechanical means, including information storage and"), _c('br'), _vm._v("retrieval systems, without permission in writing from the publisher, except by a"), _c('br'), _vm._v("reviewer, who may quote brief passages in a review. Scanning, uploading, and"), _c('br'), _vm._v("electronic distribution of this book or the facilitation of such without the permission"), _c('br'), _vm._v("of the publisher is prohibited. Please purchase only authorized electronic editions, and"), _c('br'), _vm._v("do not participate in or encourage electronic piracy of copyrighted materials. Your"), _c('br'), _vm._v("support of the author’s rights is appreciated. Any member of educational institutions"), _c('br'), _vm._v("wishing to photocopy part or all of the work for classroom use, or anthology, should"), _c('br'), _vm._v("send inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003 or"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://permissions@groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("permissions@groveatlantic.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Published simultaneously in Canada"), _c('br'), _vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("King, Lily."), _c('br'), _vm._v("The pleasing hour : a novel / by Lily King."), _c('br'), _vm._v("p.   cm."), _c('br'), _vm._v("eBook ISBN-13: 978-0-8021-9786-3"), _c('br'), _vm._v("I. Title."), _c('br'), _vm._v("PS3561.I4814P58 1999"), _c('br'), _vm._v("813′.54—dc21       99-25528")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Design by Laura Hammond Hough")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("an imprint of Grove/Atlantic, Inc."), _c('br'), _vm._v("841 Broadway"), _c('br'), _vm._v("New York, NY 10003")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Distributed by Publishers Group West"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.groveatlantic.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12612b6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 72
// module chunks = 0